import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice.js'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'

const combinedReducer = {
  header : headerSlice,
  rightDrawer : rightDrawerSlice,
  modal : modalSlice,
}

export default configureStore({
    reducer: combinedReducer
})